import MyContext from './AppContext';
import { ReactNode, useEffect, useState } from 'react';
import { UsuarioConfigs } from '../types/usuario_config';

interface MyProviderProps {
  children: ReactNode;
}

export const initialState: UsuarioConfigs = {
  modulo: 0,
  username: '',
  cor_fonte_zebrado_tabela: '',
  cor_fundo_zebrado_tabela: '',
  nome: '',
  navbar: false
};

export const MyProvider: React.FC<MyProviderProps> = ({ children }) => {
  const configs = UsuarioConfigs.GetConfigs();

  const [state, setState] = useState<UsuarioConfigs>(configs || initialState);

  const updateState = (newState: UsuarioConfigs) => {
    setState(newState);
    UsuarioConfigs.SetConfigs(newState);
  };

  useEffect(() => {
    UsuarioConfigs.SetConfigs(state);
  }, [state]);

  return (
    <MyContext.Provider value={{ state, setState: updateState }}>
      {children}
    </MyContext.Provider>
  );
};
